import { SearchableSelectBox } from "@root/shared/components/SearchableSelectBox";
import { useState } from "react";
import { SelectBox } from "@root/shared/components/SelectBox";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

export type ClientShopSelectorProps = {
  clientShopId: number | undefined;
  onClientShopChange: (clientShopId: number | undefined) => void;
  clientShops: readonly { value: number; label: string }[];
  prefectureId: number | undefined;
  onPrefectureChange: (prefectureId: number | undefined) => void;
  prefectures: readonly { value: number; label: string }[];
  shopLengthOfPrefecture: number;
};

export const ClientShopOrPrefectureSelector = (props: ClientShopSelectorProps) => {
  const {
    clientShopId,
    onClientShopChange,
    clientShops,
    prefectureId,
    onPrefectureChange,
    prefectures,
    shopLengthOfPrefecture,
  } = props;

  const [selectMode, setSelectMode] = useState<"clientShop" | "prefecture">("clientShop");

  const handleShopModeClick = () => {
    setSelectMode("clientShop");
    onPrefectureChange(undefined);
  };

  const handlePrefectureModeClick = () => {
    setSelectMode("prefecture");
    onClientShopChange(undefined);
  };

  return (
    <>
      <div className={styles.headerContainer}>
        <h3 className={styles.header}>
          <Icon name="shop" className={styles.shopIcon} />
          勤務地を指定したい場合はこちら
        </h3>
        {selectMode === "prefecture" && shopLengthOfPrefecture > 0 && (
          <p className={styles.shopCountContainer}>
            この都道府県の店舗
            <span className={styles.shopCount} aria-label="都道府県の店舗数">
              {shopLengthOfPrefecture}
            </span>
            店舗
          </p>
        )}
      </div>
      <div className={styles.selectorContainer}>
        <div className={styles.buttonContainer}>
          <button
            type="button"
            className={`${styles.toggleButton} ${selectMode === "clientShop" ? styles.toggleButtonActive : ""}`}
            onClick={handleShopModeClick}
          >
            店舗
          </button>
          <button
            type="button"
            className={`${styles.toggleButton} ${selectMode === "prefecture" ? styles.toggleButtonActive : ""}`}
            onClick={handlePrefectureModeClick}
          >
            都道府県
          </button>
        </div>
        <div className={styles.shopSelectBoxContainer}>
          {selectMode === "clientShop" && (
            <SearchableSelectBox
              value={clientShopId}
              onChange={onClientShopChange}
              options={clientShops}
              placeholder="店舗を選択する（入力して絞り込むこともできます）"
              noOptionsMessage="条件に一致する店舗がありません"
              aria-label="店舗選択"
            />
          )}
          {selectMode === "prefecture" && (
            <SelectBox
              value={prefectureId}
              onChange={({ target: { value } }) =>
                onPrefectureChange(value ? Number(value) : undefined)
              }
              options={prefectures}
              placeholder="都道府県を選択する"
              selected={prefectureId !== undefined}
              className={styles.prefectureSelectBox}
              aria-label="都道府県選択"
            />
          )}
        </div>
      </div>
    </>
  );
};
